import { Field } from "formik";
import { useState } from "react";

const PasswordBox = ({
  label,
  name,
  isRequired,
  placeholder,
  value,
  defaultValue,
  handleChange,
  maxLength,
  minLength,
  errormsg,
  fieldFlag,
  disabled,
  variant = "default", // 👈 important
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const isTextVariant = variant === "text";

  return (
    <>
      <div className={isTextVariant ? "textBoxField" : "form-group"}>
        <label
          htmlFor={name}
          className={isTextVariant ? "" : "cp-field-label"}
        >
          {label}
          {isRequired && <span className="required-star">*</span>}
        </label>

        <div
          className={
            isTextVariant
              ? "dfltText position-relative"
              : "cp-input-wrap position-relative"
          }
        >
          <Field
            type={showPassword ? "text" : "password"}
            name={name}
            id={name}
            disabled={disabled}
            value={value ?? defaultValue ?? ""}
            onChange={(e) => handleChange(e, fieldFlag)}
            placeholder={placeholder}
            autoComplete="new-password"
            className={
              isTextVariant
                ? `formik-input ${
                    disabled ? "disabled" : ""
                  } ${errormsg ? "errorField" : ""}`
                : `form-control ${errormsg ? "is-invalid" : ""}`
            }
            style={{ width: "100%", paddingRight: "40px" }}
            {...(maxLength && maxLength > 0 ? { maxLength } : {})}
            {...(minLength && minLength > 0 ? { minLength } : {})}
          />

          {!disabled && (
            <span
              className={
                isTextVariant ? "password-eye" : "cp-toggle-btn"
              }
              onClick={() => setShowPassword((prev) => !prev)}
              style={{ cursor: "pointer" }}
            >
              <i
                className={`bi ${
                  showPassword ? "bi-eye-slash" : "bi-eye"
                }`}
              />
            </span>
          )}

          
        </div>
        {errormsg && (
            <div
              className={
                isTextVariant
                  ? "error-message"
                  : "cp-invalid-feedback"
              }
            >
              {errormsg}
            </div>
          )}
      </div>
    </>
  );
};

export default PasswordBox;
